import get from 'lodash/get';
import { createSelector } from 'reselect';
import { createNotificationsManagerUrl } from './utils';
import { userControlTokenSelector, emailSelector } from '../Authentication/selectors';

export const hostSelector = state => get(state, ['trovit', 'host']);

export const verticalPathSelector = state => get(state, ['config', 'verticalPath']);

export const notificationsManagerUrlSelector = createSelector(
  [hostSelector, verticalPathSelector, userControlTokenSelector, emailSelector],
  (domain, verticalPath, userControlToken, email) =>
    createNotificationsManagerUrl(domain, verticalPath, userControlToken, email)
);



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/CallToActionLink/selectors.js